// Entity.js - Contains entity classes for game objects

export class Pacman {
  constructor() {
    this.x = 1;
    this.y = 1;
    this.direction = 'right';
    this.speed = 0.08; // Reduced speed for better control in tight spaces
    this.mouthAngle = 0;
    this.mouthOpening = true;
    this.isPowered = false;
    this.powerTimer = 0;
    this.nextDirection = null; // Buffer for smoother direction changes
  }

  reset() {
    this.x = 1;
    this.y = 1;
    this.direction = 'right';
    this.speed = 0.1;
    this.mouthAngle = 0;
    this.mouthOpening = true;
    this.isPowered = false;
    this.powerTimer = 0;
  }
}

export class Ghost {
  constructor() {
    this.x = 13;
    this.y = 8;
    this.speed = 0.08;
    this.color = 'red';
  }

  reset() {
    this.x = 13;
    this.y = 8;
    this.speed = 0.08;
    this.color = 'red';
  }
}

export const createFoods = (gameMap) => {
  const foods = {};

  // Create special food items (fruit, burger, pizza)
  foods.fruit = { x: 7, y: 5, eaten: false, scoreAdded: false, type: 'fruit' };
  foods.burger = { x: 3, y: 3, eaten: false, scoreAdded: false, type: 'burger' };
  foods.pizza = { x: 11, y: 7, eaten: false, scoreAdded: false, type: 'pizza' };

  // Create dots in all empty spaces (where map has 0)
  for (let y = 0; y < gameMap.length; y++) {
    for (let x = 0; x < gameMap[y].length; x++) {
      if (gameMap[y][x] === 0) { // Empty space
        const dotKey = `dot_${x}_${y}`;
        foods[dotKey] = {
          x: x,
          y: y,
          eaten: false,
          scoreAdded: false,
          type: 'dot'
        };
      }
    }
  }

  return foods;
};
